import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Redirect } from 'react-router-dom';

import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from './../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	//obter_distrito_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,

	//get_vat_info,

	pattern_vat,
	pattern_email, 
	passwordHash,

} from '../../../Utils';

import { language } from './Language';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);

	const [lang, /*set_lang*/] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, set_is_password] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	//const [is_input_disabled, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	//const [newDate, ] = useState(new Date())
	//const [today , ] = useState(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, "0") + '-' + newDate.getDate().toString().padStart(2, "0"))

	const [/*show_vat_form*/, set_show_vat_form] = useState('');
	const [/*show_district_city_village*/, set_show_district_city_village] = useState('');

	const [/*disabled*/, set_disabled] = useState(false)

	const [/*hidePessoal*/, set_hide_pessoal] = useState('')
	const [/*hideEmpresarial*/, set_hide_empresarial] = useState('')

	const entity_types = [
		{ value: "Ski", label: "Ski" },
		{ value: "Snowboard", label: "Snowboard" }
	];

	const identification_types = [
		{ value: "Bilhete de Identidade", label: "Bilhete de Identidade" },
		{ value: "Cartão de Cidadão", label: "Cartão de Cidadão" }
	];

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])

	const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "2px 10px",
			fontSize: '14px'
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
		}),
	}

	const change_country = e => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === "Portugal") {

			set_show_district_city_village('')

			if (districts.length === 0) {
				//console.log('DISTRITOS VAZIOS')
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = e => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = e => {

		set_villages([])

		obter_freguesias_por_cidade(e.value, set_villages)

		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = e => {
		set_dados(dados.current.addresses[0].village = e.value);
		set_dados(dados)
	}

	const change_entity_type = e => {
		set_dados(dados.current.info.entity_type = e.value);

		if (e.value.localeCompare('Pessoal') === 0) {
			set_hide_pessoal('');
			set_hide_empresarial('d-none');
		}
		else {
			set_hide_pessoal('d-none');
			set_hide_empresarial('');
		}
	}

	const change_identification_type = e => {
		set_dados(dados.current.info.identificacao.tipo_identificacao = e.value);
	}

	/*const change_district_by_city = async e => {

		return await obter_distrito_por_cidade(e.value)
			.then(res =>
				change_district({ value: res })
			).catch(() => { return })
	}*/

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
				//console.log(res)

			})
			.catch(error => alert(error)/*TODO: GO TO FAIL FETCH*/)
	}
	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	// PARA INSTANCIAR O COMPONENTE COM O ID 
	//const props_tmp = props
	useEffect(() => {

		clean_data();
		obter_paises_em_pt(set_countries);

		if(getTokenInfo().profile === 'Colaborador') {

			set_is_edit(true)

			set_show_delete_button('d-none')

			fetch_id_info(getTokenInfo().id).then(() => {

				//console.log(dados.current)
				if (dados.current.addresses[0].country === 'Portugal') {

					obter_distritos_pt(set_districts)

					obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

					obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					setLoading(false);
				}
				else {
					set_show_district_city_village('d-none')
					setLoading(false);
				}
			})
			return

		}
	
		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_vat_form('d-none')

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {

					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {

						obter_distritos_pt(set_districts)

						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
						setLoading(false);
					}
					else {
						set_show_district_city_village('d-none')
						setLoading(false);
					}
				})
				return
			}


		} catch {
			// VAI REGISTAR
			set_show_vat_form('');

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])



	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {
			//alert('Atualizar PUT')

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					console.log('aki', is_password)
					if(is_password) {
						console.log('aki2')
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							set_new_password('')
							set_confirm_password('')

							// props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					if(is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}

						reqPOST(api_crud_route, dados.current)
							.then(() => { 
								set_new_password('')
								set_confirm_password('')

								props.history.push(endpoints.list) 
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
			})
		}
	}

	/*const handleSubmitVat = async e => {
		e.preventDefault();

		setLoading(true);
		get_vat_info(dados.current.info.vat)
			.then(res => {
				//console.log('---------- VAT INFO --------------')
				//console.log(res)

				if ((res.data.name !== '---') && (res.data.name !== '')) {
					clean_data();
					set_dados(dados.current.info.vat = res.data.vatNumber);
					set_dados(dados.current.info.name = res.data.name);
					set_dados(dados.current.addresses[0].address_detail = res.data.address);

					let aMorada = res.data.address.split("\n");
					// Verificar se pais é PT
					if (res.data.countryCode === 'pt') {
						//console.log('----------------------> É PT')

						change_country({ value: 'Portugal' })


						set_dados(dados.current.addresses[0].street_name = aMorada[1]);

						let city = aMorada[1];
						if (city !== undefined) {
							city = city.toLowerCase();
							city = city.charAt(0).toUpperCase() + city.slice(1);
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))


							// After District -> City
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))

							let aMoradaCP = aMorada[2].split(" ");
							set_dados(dados.current.addresses[0].postal_code = aMoradaCP[0]);
						}
					} else {
						//console.log('---------------------->NÃO È PT')
						set_dados(dados.current.addresses[0].street_name = aMorada[1]);
					}
				}
				else {

					Swal.fire('VAT não encotrado na base VIES.', '', 'info')

				}
				setLoading(false)
			})

			.catch(error => { setLoading(false); alert(error) });
	}*/

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqPUT(api_crud_route, dados.current)
					.then(() => { props.history.push(endpoints.list) })
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
			}
		})
	}

	function apagar() {
		
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(res => {
						/* alert(res.status === 200 ?
							'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); */

						props.history.push(endpoints.list);
					})
					.catch(error => alert(error))

			}
		})
	};


	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`)
			.then(res => {
				//console.log(res.data)
				// res.data.map((k) => {
				// 	if(k['vat'] === vat) {
				// 		set_dados(dados.current.info.Cliente.id = k['id']);
				// 		set_dados(dados.current.info.Cliente.name = k['name']);
				// 	}
				// });

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
						//set_visible_client_name(true)
						//set_dados(dados.current.info.Cliente.name = k['vat']);
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {

					Swal.fire('Já Existe um Registo com este VAT.', '', 'info')

				}
			}
			)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/
		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.addresses[addresses_index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}


	const handle_change_info = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info[name] = value)

		if ((is_edit === false) && (name === 'vat')) {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type)
			}
		}

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_is_password(true)
		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if (new_password !== '' && value === new_password) {

			set_dados(dados.current.info.password = passwordHash(new_password))
			set_disabled(false)
		}
		else {

			Swal.fire('Password de confirmação diferente da password inserida.', '', 'info')
			set_disabled(true)
		}
	}

	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.contacts[index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info_identification = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info.identificacao[name] = value)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handleSelectType = e => {
		const { value } = e.target;

		if(dados.current.info['formacao'] === undefined || dados.current.info['formacao'].length === 0) {
			dados.current.info['formacao'] = [value]
		}
		else {
			let aux = dados.current.info['formacao'].filter(el => el === value)

			if(aux.length === 0) {
				dados.current.info['formacao'].push(value)
			}
			else {
				dados.current.info['formacao'] = dados.current.info['formacao'].filter(el => el !== value)
			}

			console.log(dados.current.info['formacao'])
		}

		set_dados(dados.current.info, )
		// setRefresh(refresh + 1)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados.current.info))
	}

	const handleTypeCheckVerify = (value) => {
		let result = false
		
		if(dados.current.info['formacao'] !== undefined) {
			let aux = dados.current.info['formacao'].filter(el => el === value)

			if(aux.length > 0)
				result = true
		}

		return result
	}

	return isloading ?
	
		<Loader />
		
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].entity}</h2>
					<p>{language[lang].entity} / { dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new }</p>
				</div>

				<div className={`dash-cards body`}>
                	<div className="container">

						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
										
											<div className="card-body border-top p-4">

												<div className="row mb-5">
													<div className="col-md-6">
														<label className="fs-6 fw-bold mb-2">{language[lang].name}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-md-3">
														<label className="fs-6 fw-bold mb-2">{language[lang].vat}</label>
														<input type="text" pattern={pattern_vat} minLength="9" inputMode='numeric' name="vat" value={dados.current.info.vat} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].vat_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-md-3 d-none">
														<label className="fs-6 fw-bold mb-2">{language[lang].type}</label>
														
														<Select
															className="div-select"
															options={entity_types}
															name="client_type"
															value={dados.current.info.entity_type === '' ? null : { label: dados.current.info.entity_type, value: dados.current.info.entity_type }}
															placeholder={language[lang].type_placeholder}
															onChange={change_entity_type}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-3 d-none">
														<label className="fs-6 fw-bold mb-2">{language[lang].type}</label>
														
														{
														['Ski', 'Snowboard'].map((element, key) => {
															return (
																<div key={key} className="form-check">
																	<label className="form-check-label text-nowrap" htmlFor={"type_" + key}>
																		{element}
																	</label>
																	<input 
																		id={"type_" + key}
																		name={"type_" + key}
																		value={element}
																		type="checkbox" 
																		className={'form-check-input rounded-0'}
																		data-id={key}
																		data-name={element}
																		onChange={handleSelectType}
																		defaultChecked={handleTypeCheckVerify(element)}
																	/>
																</div>
															)
														})
														}
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].type_identification}</label>
														
														<Select
															className="div-select"
															options={identification_types}
															name="identification_type"
															value={dados.current.info.identificacao !== undefined && dados.current.info.identificacao['tipo_identificacao'] !== undefined && dados.current.info.identificacao.tipo_identificacao !== '' ? { label: dados.current.info.identificacao.tipo_identificacao, value: dados.current.info.identificacao.tipo_identificacao } : null}
															placeholder={language[lang].type_identification_placeholder}
															onChange={change_identification_type}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].identification_number}</label>
														<input type="text" pattern="\d*" inputMode='numeric' maxLength="11" name="numero_identificacao" value={dados.current.info.identificacao !== undefined && dados.current.info.identificacao['numero_identificacao'] !== undefined ? dados.current.info.identificacao.numero_identificacao : ''} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].identification_number_placeholder} onChange={handle_change_info_identification} required />
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].identification_validation}</label>
														<input type="date" name="validade_identificacao" value={dados.current.info.identificacao !== undefined && dados.current.info.identificacao['validade_identificacao'] !== undefined  && dados.current.info.identificacao.validade_identificacao !== '' ? dados.current.info.identificacao.validade_identificacao : ''} className="form-control mb-3 mb-lg-0 rounded-0" onChange={handle_change_info_identification} /> 
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].tlf}</label>

														<PhoneInput
															defaultCountry="PT"
															className="form-control mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].tlf_placeholder}
															value={dados.current.contacts[0].phone !== '' ? dados.current.contacts[0].phone : null}
															onChange={e => set_dados(dados.current.contacts[0].phone = e)} 
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].tlm}</label>
														<PhoneInput
															defaultCountry="PT"
															className="form-control mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].tlm_placeholder}
															value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
															onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)} 
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].email}</label>
														<input type="email" pattern={pattern_email} name="email" value={dados.current.contacts[0].email} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_contacts} />
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].country}</label>
														<Select
															className="div-select"
															options={countries}
															name="pais"
															value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
															placeholder={language[lang].country_placeholder}
															onChange={change_country}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].district}</label>
														<Select
															className="div-select"
															options={districts}
															name="distrito"
															value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
															placeholder={language[lang].district_placeholder}
															onChange={change_district}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].city}</label>
														<Select
															className="div-select"
															options={cities}
															name="concelho"
															value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
															placeholder={language[lang].city_placeholder}
															onChange={change_city}
															styles={custom_select_styles}
														/>
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].village}</label>
														<Select
															className="div-select"
															options={villages}
															name="freguesia"
															value={dados.current.addresses[0].village === '' ? null : { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }}
															placeholder={language[lang].village_placeholder}
															onChange={change_village}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].local}</label>
														<input type="text" name="localidade" value={dados.current.addresses[0].localidade} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].local_placeholder} onChange={handle_change_addresses} required />

													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].postal_code}</label>
														<input type="text" name="postal_code" value={dados.current.addresses[0].postal_code} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_addresses} required />
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-6">
														<label className="fs-6 fw-bold mb-2">{language[lang].morada}</label>
														<textarea name="address_detail" value={dados.current.addresses[0].address_detail} className="form-control mb-3 mb-lg-0 rounded-0" rows="4" onChange={handle_change_addresses} required />
													</div>

												</div>

											</div>

										</form>
									</div>
								</div>

								<div className="card mt-5">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
										</div>
									</div>
									<div id="div_entidade_password" className="collapse show">
										<form id="form" onSubmit={handleSubmitPassword}>

											<div className="card-body border-top p-4">

												<div className="row mb-6">
													<div className="col-md-4 fv-row">
														<label className="fs-6 fw-bold mb-2">{language[lang].username}</label>
														<input type="text" name="username" value={dados.current.info.username} pattern="[a-zA-Z\u00C0-\u00FF.]+" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} autoComplete="off" required />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-6 fw-bold mb-2">{language[lang].password}</label>
														<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-6 fw-bold mb-2">{language[lang].password_confirmation}</label>
														<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onBlur={handle_change_password} autoComplete="off" />
													</div>
												</div>

												<div className="card-footer d-flex justify-content-end py-6 px-9 d-none">
													<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
														<span>{language[lang].cancel}</span>
													</Link>

													<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
														<span>{language[lang].delete}</span>
													</button>

													<button type="submit" form="form" className="btn btn-primary">
														<span>{language[lang].save}</span>
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
